import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {
  getPbssFilesList,
  deletePbssFile,
} from '../../../Store/Actions/pbssFiles';
import {DefaultPaginationValues} from '../../../Util/commonUtility';
import PbssFilesComponent from '../../../Components/AdminComponents/PbssFiles';

const PbssFilesContainer = () => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paging, setPaging] = useState({
    page: DefaultPaginationValues.PAGE,
    pageCount: DefaultPaginationValues.PAGE_SIZE,
    totalCount: 0,
    totalPage: 1,
  });
  const [selectedType, setSelectedType] = useState('pbss_international');
  const [selectedFormat, setSelectedFormat] = useState('all');

  const fetchList = useCallback(
    async (
      page = paging.page,
      pageCount = paging.pageCount,
      type = selectedType,
      format = selectedFormat,
    ) => {
      // setLoading(true);
      const data = await dispatch(
        getPbssFilesList({
          page,
          pageCount,
          type: type === 'all' ? '' : type || 'international',
          format: format && format !== 'all' ? format : undefined,
        }),
      );
      setLoading(false);
      if (data) {
        setFiles(data.files || []);
        setPaging((prev) => ({
          ...prev,
          page: data.currentPage || page,
          pageCount: data.pageCount || pageCount,
          totalCount: data.totalCount || 0,
          totalPage: data.totalPage || 1,
        }));
      }
    },
    [dispatch, selectedType, selectedFormat],
  );

  useEffect(() => {
    fetchList(paging.page, paging.pageCount, selectedType, selectedFormat);
  }, [paging.page, paging.pageCount, selectedType, selectedFormat]);

  const handlePaginationChange = (page, pageSize) => {
    setPaging((prev) => ({
      ...prev,
      page,
      pageCount: pageSize,
    }));
  };

  const handleFilterChange = (value) => {
    setSelectedType(value || 'international');
    setPaging((prev) => ({...prev, page: 1}));
  };

  const handleFormatFilterChange = (value) => {
    setSelectedFormat(value || 'all');
    setPaging((prev) => ({...prev, page: 1}));
  };

  const handleDelete = (id) => {
    return dispatch(deletePbssFile(id));
  };

  return (
    <PbssFilesComponent
      files={files}
      loading={loading}
      paging={paging}
      onPaginationChange={handlePaginationChange}
      onFilterChange={handleFilterChange}
      onFormatFilterChange={handleFormatFilterChange}
      selectedType={selectedType}
      selectedFormat={selectedFormat}
      onDelete={handleDelete}
      fetchList={() =>
        fetchList(paging.page, paging.pageCount, selectedType, selectedFormat)
      }
    />
  );
};

export default PbssFilesContainer;
